import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AccommodationBookingForm.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import DateTimeInput from '../../../../../../moreCore/UI/DateTimeInput/DateTimeInput';
import NumberInput from '../../../../../../moreCore/UI/NumberInput/NumberInput';
import { AdditionalFormSaveData, TravelBookingLoadData } from "../../../TravelBookingListTypes";

class AccommodationBookingForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private entity: TravelBookingLoadData;

    private currentDateStart: Date;
    private currentDateEnd: Date;
    private currentQuantityNights: number;

    private dateStartInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private quantityNightsInput: MdsLax<InstanceType<typeof NumberInput>>;
    private dateEndInput: MdsLax<InstanceType<typeof DateTimeInput>>;

    onInputChange(e): void {
        this.emit("change");
    }

    private _resetInputs() {
        this.dateStartInput.setValue(this.currentDateStart, true);
        this.dateEndInput.setValue(this.currentDateEnd, true);
        this.quantityNightsInput.setValue(this.currentQuantityNights, true);

    }

    private _onChangeDateEnd(e) {
        var dateStart = this.dateStartInput.getValue().date;
        var dateEnd = this.dateEndInput.getValue().date;
        var quantityNights = this.quantityNightsInput.getValue();

        var success = true;

        if (dateStart && dateEnd) {
            if (this.compareDates(dateEnd, dateStart) >= 0) {
                var days = this.calculateDayDifference(dateStart, dateEnd);
                this.quantityNightsInput.setValue(days, true);
            } else {
                success = false;
                this.showToast(this.translate("TravelBookingForm_Error_DateEnd"), "fas fa-exclamation-triangle");
            }
        } 

        if (success) {
            this.currentDateEnd = this.dateEndInput.getValue().date;
            this.currentQuantityNights = this.quantityNightsInput.getValue();

            this.onInputChange(e);
        } else {
            this._resetInputs();
        }
    }

    private _onChangeDateStart(e) {
        var dateStart = this.dateStartInput.getValue().date;
        var dateEnd = this.dateEndInput.getValue().date;
        var quantityNights = this.quantityNightsInput.getValue();

        var success = true;

        if (this.dateStartInput.getValue().date && this.dateEndInput.getValue().date) {
            if (this.compareDates(dateStart, dateEnd) <= 0) {
                var days = this.calculateDayDifference(dateStart, dateEnd);
                this.quantityNightsInput.setValue(days, true);
            } else {
                success = false;
                this.showToast(this.translate("TravelBookingForm_Error_DateStart"), "fas fa-exclamation-triangle");
            }
        } 

        if (success) {
            this.currentDateStart = this.dateStartInput.getValue().date;
            this.currentQuantityNights = this.quantityNightsInput.getValue();

            this.onInputChange(e);
        } else {
            this._resetInputs();
        }
    }

    private _onChangeDuration(e): void {
        var newDays = this.quantityNightsInput.getValue();
        if (this.dateStartInput.getValue().date && this.dateEndInput.getValue().date && newDays >= 0) {
            var oldDays = this.calculateDayDifference(this.dateStartInput.getValue().date, this.dateEndInput.getValue().date);
            var dayDifference = newDays - oldDays;

            var newDateEnd = this.calculateDateDifference(this.dateEndInput.getValue().date, dayDifference);
            this.dateEndInput.setValue(newDateEnd, true);

            this.currentQuantityNights = newDays;
            this.currentDateEnd = newDateEnd;

            this.onInputChange(e);
        } else {
            this.quantityNightsInput.setValue(this.currentQuantityNights, true);
        }
    }

    private compareDates(date1: Date, date2: Date): number {
        var result: number;

        result = date1.getTime() - date2.getTime();

        //If result === 0: date1 and date2 are equal
        //If result < 0: date2 is greater than date1
        //If result > 0: date1 is greater than date2
        return result;
    }

    calculateDateDifference(dateStart: Date, difference: number) {
        var newDateEnd = new Date(dateStart.toString());
        newDateEnd.setDate(newDateEnd.getDate() + difference);
        return newDateEnd;
    }

    private calculateDayDifference(dateStart: Date, dateEnd: Date): number {
        var timeDifference = dateEnd.getTime() - dateStart.getTime();

        var dayDifference = Math.round(timeDifference / (1000 * 60 * 60 * 24));

        return dayDifference;
    }

    getData(): AdditionalFormSaveData {
        var formData: AdditionalFormSaveData = {
            date_start: this.dateToLocalISOString(this.dateStartInput.getValue().date),
            qty_nights: this.quantityNightsInput.getValue(),
            date_end: this.dateToLocalISOString(this.dateEndInput.getValue().date),
        };

        return formData;
    }


    prepareData(entity?): void {
        if (entity) {
            this.setEntity(entity);
        } else {
            this.dateStartInput.setValue(null, true);
            this.quantityNightsInput.setValue(null, true);
            this.dateEndInput.setValue(null, true);
        }
        this.currentDateStart = this.dateStartInput.getValue() ? this.dateStartInput.getValue().date : null;
        this.currentDateEnd = this.dateEndInput.getValue() ? this.dateEndInput.getValue().date : null;
        this.currentQuantityNights = this.quantityNightsInput.getValue();

    }

    private setEntity(entity) {
        this.entity = entity;
        this.dateStartInput.setValue(entity.date_start, true);
        this.quantityNightsInput.setValue(entity.qty_nights, true);
        this.dateEndInput.setValue(entity.date_end, true);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AccommodationBookingForm);